import Flickity from 'flickity';

class MatchBarCarousel
{
    constructor()
    {
        this.flkty = null;
        this.animationDuration = 200;

        this.flktyJumpDistance = 60;
        this.flktyIsDragging = false;

        this.interval = null;
        this.inactivityMaxTime = 10;
        this.inactivity = 0;

        this.$navLeft = $('.gamebar-nav-left');
        this.$navRight = $('.gamebar-nav-right');
    }

    resetInactivity()
    {
        this.inactivity = 0;

        if (this.interval)
        {
            clearInterval(this.interval);
        }
        this.interval = setInterval
        (
            () =>
            {
                const $item = $('.gamebar-item-current');
                const $tooltip = $('.gamebar-item .tippy-active');

                if ($tooltip.length)
                {
                    this.resetInactivity();
                }
                this.inactivity++;

                if (this.inactivity > this.inactivityMaxTime)
                {
                    const index = $item.index();
                    this.change(index, true);
                }
            }, 1000
        );
    }

    tooltipActivation(active)
    {
        const btns = document.querySelectorAll('.gamebar-popover-trigger, .gamebar-approval-trigger');
        for (let i = 0; i < btns.length; i++)
        {
            const tippy = btns[i]._tippy;
            if (tippy === void 0) {
                continue;
            }

            if (active)
            {
                tippy.enable();
            }
            else
            {
                tippy.hide();
                tippy.disable();
            }
        }
    }

    events()
    {
        $(window).resize(() => {
            const index = $('.gamebar-item-current').index();
            this.change(index, true);
        });

        this.flkty.on('select', (index) => {
            this.change(index);
        });

        this.flkty.on('settle', (index) => {
            this.tooltipActivation(true);
        });

        this.flkty.on('dragStart', () => {
            setTimeout(() => {
                this.flktyIsDragging = true;
            }, 100);
            this.tooltipActivation(false);
        });

        this.flkty.on('dragEnd', () => {
            setTimeout(() => {
                this.flktyIsDragging = false;
            }, 100);
            this.tooltipActivation(true);
        });

        const applyAnimationFunc = function(prev, next, duration)
        {
            $('.flickity-slider').each
            (
                function()
                {
                    this.jump = prev;
                }
            ).animate
            (
                {
                    jump: next
                },
                {
                    step: function(now, fx)
                    {
                        $(this).css('transform', 'translateX(' + now + 'px)');
                    },
                    duration: duration
                },
                'ease-in'
            );

            const $section = $('.gamebar-section-rwd');
            const $sponsors = $('.gamebar-section-sponsors');
            $section.slideUp(duration);
            $sponsors.slideUp(duration);
        }

        this.$navLeft.on('click', () => {

            const prev = this.flkty.x + this.flkty.cursorPosition;
            let next = prev + this.flktyJumpDistance;

            this.flkty.x += this.flktyJumpDistance;

            if (next > 0)
            {
                next = 0;
                this.flkty.x = -this.flkty.cursorPosition;
            }

            applyAnimationFunc(prev, next, this.animationDuration);
            this.resetInactivity();
        })

        this.$navRight.on('click', () => {

            const prev = this.flkty.x + this.flkty.cursorPosition;
            let next = prev - this.flktyJumpDistance;

            this.flkty.x -= this.flktyJumpDistance;

            if (next < -this.flkty.slidesWidth)
            {
                next = -this.flkty.slidesWidth;
                this.flkty.x = next - this.flkty.cursorPosition;
            }

            applyAnimationFunc(prev, next, this.animationDuration);
            this.resetInactivity();
        })

        const classPointer = this;

        $('.gamebar-item-current').on('click', function(event)
        {
            if (!classPointer.flktyIsDragging)
            {
                const index = $(this).index();
                classPointer.change(index, true);
            }
        });
    }

    change(index, select)
    {
        if (select)
        {
            this.tooltipActivation(false);
            this.flkty.select(index);
        }
        this.toggleInformationSection(index);
        this.handleNavigation(index);

        this.resetInactivity();
    }

    handleNavigation(index)
    {
        const cells = this.flkty.cells.length;

        ((index + 1) >= cells) ? this.$navRight.addClass('disabled') : this.$navRight.removeClass('disabled');
        (index < 1) ? this.$navLeft.addClass('disabled') : this.$navLeft.removeClass('disabled');
    }

    toggleLoadingMode(loading)
    {
        $('.gamebar-section').toggleClass('is-loading', loading);
    }

    toggleInformationSection(index)
    {
        const $current = $('.gamebar-item').eq(index);
        const $section = $('.gamebar-section-rwd');
        const $sponsors = $('.gamebar-section-sponsors');

        if ($current.hasClass('gamebar-item-current'))
        {
            $section.slideDown(this.animationDuration);
            $sponsors.slideDown(this.animationDuration);

            setTimeout(function() {
                $('#gamebar-section').css('min-height', 'auto');

                let v = window.screen.width > 1024 ? 'desktop' : 'tablet';
                if (window.screen.width < 769) {
                    v = 'mobile';
                }

                const height = $('#gamebar-section').outerHeight();
                window.localStorage.setItem(v + '-matchbar-min-height', height);
            }, 1000);
        }
        else
        {
            $section.slideUp(this.animationDuration);
            $sponsors.slideUp(this.animationDuration);
        }
    }

    replace(html)
    {
        const $current = $('.gamebar-item-current');
        $current.html(html);
    }

    slider()
    {
        const slider = document.querySelector('.gamebar-list');
        const classPointer = this;

        const $current = $('.gamebar-item-current');
        const initial = $current.length ? $current.index() : 0;

        this.flkty = new Flickity
        (
            slider,
            {
                contain: true,
                prevNextButtons: false,
                pageDots: false,
                cellAlign: 'center',
                initialIndex: initial,
                percentPosition: false,
                accessibility: false,
                on:
                {
                    ready: function()
                    {
                        classPointer.toggleLoadingMode(false);
                        classPointer.toggleInformationSection($current);
                    }
                }
            }
        );
    }

    init()
    {
        const slider = document.querySelector('.gamebar-list');
        const classPointer = this;

        const $current = $('.gamebar-item-current');
        const initial = $current.length ? $current.index() : 0;

        this.slider();

        this.events();
        this.change(initial);
    }
}

export default MatchBarCarousel;



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/match-bar/carousel.js